export default(number: number, places: number = 2) => { 
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: places,
    maximumFractionDigits: places,
  })
  
  return formatter.format(number)
}